import { useGetLinkRel } from '~/shared';
import { applicationSettings } from '~/shared/application.settings';
import { navigate as navigateIntl } from 'gatsby-plugin-intl';

export const useNavigateLink = (to) => {
  const { isExternal, url } = useGetLinkRel(to);

  const getNavigateFn = () => {
    if (typeof window === `undefined`) return;
    if (url?.startsWith(applicationSettings.MAIN_SITE_REWRITE_PATH) || isExternal) {
      return window.location.assign.bind(window.location);
    }
    return navigateIntl;
  };

  return { getNavigateFn };
};
